export default __webpack_public_path__ + "static/media/angle-down-regular.751961b8.svg";